import styled from "styled-components";
import {
  CARD_GRID_COLUMN_GAP,
  CARD_GRID_ROW_GAP,
} from "../../config/layoutConfig";

const CARD_GRID_COLUMN_GAP_STYLED = `${CARD_GRID_COLUMN_GAP}px`;
const CARD_GRID_ROW_GAP_STYLED = `${CARD_GRID_ROW_GAP}px`;

export const CardGridWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  /* justify-content: left; */
  /* align-items: center; */

  width: ${(props) => props.innerWidth};
  padding: ${CARD_GRID_COLUMN_GAP_STYLED};
  column-gap: ${CARD_GRID_COLUMN_GAP_STYLED};
  row-gap: ${CARD_GRID_ROW_GAP_STYLED};
  font-family: "Open Sans", "sans-serif";
  z-index: -1;
  background-color: rgba(255, 255, 255, 0.9);
  transition: height 4s ease;

  .ant-card {
    /* display: inline-block;
    width: 340px;
    height: 300px;
    margin-right: 10px;
    margin-bottom: 10px; */
  }

  .ant-image-img {
    object-fit: cover;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

  .svg-icon-bed {
    display: block;
    max-width: 20px;
    max-height: 20px;
  }

  .ahp-price {
    position: absolute;
    top: -1px;
    right: -1px;
    background-color: #bdb1c5;
    // border-radius: 50%;
    border: 4px solid white;
    width: 64px;
    height: 64px;
    display: flex;
    /* align-items: center; */
    justify-content: center;
  }

  .ahp-price > div {
    font-weight: 400;
    line-height: 1rem;
  }

  .ahp-price-value {
    color: white;
    margin-top: 18px;
  }

  .ahp-price-info {
    position: absolute;
    bottom: 8px;
    border-radius: 50%;
    background-color: white;
    width: 14px;
    height: 14px;
    color: grey;
    font-size: 12px;
    margin: auto auto;
    line-height: 12px;
    text-align: center;
  }
  // .room-price.p {
  //   margin: auto auto;
  //   float: none;
  //   display: inline;
  // }

  .reservation-conf {
    margin-top: -6px;
    text-align: center;
    color: white;
    padding: 3px 0px;
    text-transform: uppercase;
  }

  .confirmed {
    background-color: #82b8ba;
  }
  .not-confirmed {
    background-color: orange;
  }

  .availability {
    margin-top: -2px;
    text-align: center;
    color: white;
    padding: 3px 0px;
    text-transform: uppercase;
    font-size: 10px;
    width: 100%;
  }

  .available {
    background-color: #82b8ba;
  }
  .not-available,
  .pending {
    background-color: #f39677;
  }
  .not-defined {
    background-color: lightgrey;
  }

  .rejected {
    background-color: red;
  }

  .card-body {
    position: relative;
    padding: 0px 20px 10px 20px;
  }

  .ahp-store-name,
  .ahp-product-name {
    padding: 3px;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    background-color: rgb(76, 76, 76);
    color: white;
  }
  .ahp-store-name {
    font-size: 0.7rem;
  }
  .ahp-product-name {
    font-size: 1rem;
  }

  .short-description {
    margin: 10px 0px;
  }

  p {
    margin: 0;
  }

  // card

  .ant-card {
  }

  .ant-card .ant-card-bordered .ant-card-hoverable {
    flex: 1;
  }

  .ant-image {
    text-align: center;
  }
  .ant-image-img {
    max-height: 140px;
  }

  .ant-card-body {
    padding: 0;
    margin: -1px;
  }

  .ant-card-bordered {
    border-color: lightgrey;
  }
`;
